import React from 'react';

import { Carousel, Image } from 'react-bootstrap';
import useDynamicContent from 'hooks/Home/useDynamicContent';

import './index.scss';

export default function DynamicContent() {
  const {
    interval,
    transitionType,
    autoplay,
    images,
  } = useDynamicContent();

  return (
    <div className="dynamic-content-card mb-4">
      {images.length > 0 && (
        <Carousel
          indicators
          className="home-carousel"
          interval={autoplay ? interval * 1000 : undefined}
          fade={transitionType === 'fade'}
        >
          {images.map((image) => (
            <Carousel.Item key={image}>
              <div className="d-flex justify-content-center h-100 w-100">
                {image && (
                  <Image src={image} className="mx-2" />
                )}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

      )}
    </div>
  );
}
